import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ModalContextType {
  isVisible: boolean;
  showModal: () => void;
  hideModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const showModal = (e?: any) => {document.body.style.height = "100vh";document.body.style.overflow = "hidden";setIsVisible(true);}
  const hideModal = (e?: any) => {document.body.style.overflow = "auto";setIsVisible(false);}

  return (
    <ModalContext.Provider value={{ isVisible, showModal, hideModal }}>
      {children}
    </ModalContext.Provider>
  );
};

// 自定义 hook
export const useModal = (): ModalContextType => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
